export default {
    values: {
        Purge: 'Purge',
        'Purge History': 'Purge History',
        'Purge rule successfully removed': 'Purge rule successfully removed',
        'Failed to remove the purge rule': 'Failed to remove the purge rule',
        'There are no purge rules configured.': 'There are no purge rules configured.',
        'You can add a new rule to test and run a one-time data purge event.':
            'You can add a new rule to test and run a one-time data purge event.',
        Simulate: 'Simulate',
        'Run purge': 'Run purge',
        Cancel: 'Cancel',
        Recurrence: 'Recurrence',
        Action: 'Action',
        'Event type': 'Event type',
        'Time range': 'Time range',
        'One-Time': 'One-Time',
        Delete: 'Delete',
        'Add new rule': 'Add new rule',
        'No purges or simulations': 'No purges or simulations',
        Date: 'Date',
        Type: 'Type',
        'Started by': 'Started by',
        Status: 'Status',
        completed: 'completed',
        canceling: 'canceling',
        running: 'running',
        waiting: 'waiting',
        failed: 'failed',
        canceled: 'canceled',
        Simulation: 'Simulation',
        'Purge Id': 'Purge Id',
        'show more': 'show more',
        'Purge will still run in the background if you exit this page':
            'Purge will still run in the background if you exit this page',
        'Purge rule successfully edited': 'Purge rule successfully edited',
        'Failed to edit the purge rule': 'Failed to edit the purge rule',
        'Edit rule': 'Edit rule',
        'Insert an event type': 'Insert an event type',
        'Invalid event type': 'Invalid event type',
        'Add a time range': 'Add a time range',
        'Invalid time range': 'Invalid time range',
        Edit: 'Edit',
        'Purge details': 'Purge details',
        Yes: 'Yes',
        No: 'No',
        'Elapsed time': 'Elapsed time',
        'Rules executed': 'Rules executed',
        'Total events': 'Total events',
        'Rule details': 'Rule details',
        Ok: 'Ok',
        'New purge rule successfully created': 'New purge rule successfully created',
        'Purge rule already exists': 'Purge rule already exists',
        'Failed to create the purge rule': 'Failed to create the purge rule',
        'New rule': 'New rule',
        'Executed in': 'Executed in',
        'and listed': 'and listed',
        event: 'event',
        events: 'events',
        Configuration: 'Configuration',
        'Purge Settings': 'Purge Settings',
        'Failed to get the purge configuration': 'Failed to get the purge configuration',
        'Settings successfully saved': 'Settings successfully saved',
        'Failed to save settings': 'Failed to save settings',
        'Maximum duration': 'Maximum duration',
        'Value must be greater than 0': 'Value must be greater than 0',
        hourString: ({ maxDuration }) => (maxDuration > 1 ? 'hours' : 'hour'),
        dayString: ({ maxDuration }) => (maxDuration > 1 ? 'days' : 'day'),
        minuteString: ({ maxDuration }) => (maxDuration > 1 ? 'minutes' : 'minute'),
        Recurrent: 'Recurrent',
        'Enable scheduled rules': 'Enable scheduled rules',
        'This control enables/disables the execution of scheduled purge rules following the configured Cron':
            'This control enables/disables the execution of scheduled purge rules following the configured Cron',
        Cron: 'Cron',
        Keep: 'Keep',
        'Exception details': 'Exception details',
        'Purge exception already exists': 'Purge exception already exists',
        'Purge exception successfully edited': 'Purge exception successfully edited',
        'Failed to edit the purge exception': 'Failed to edit the purge exception',
        'New purge exception successfully created': 'New purge exception successfully created',
        'Failed to create the purge exception': 'Failed to create the purge exception',
        'Purge exception successfully removed': 'Purge exception successfully removed',
        'Failed to remove the purge exception': 'Failed to remove the purge exception',
        'Estimated space saving': 'Estimated space saving',
        'Message about estimated space saving':
            'The effective space savings depend on the underlay storage technology. Some providers need a vacuum or compact operation to reclaim the disk space.',
        PerformExtraAction: ({ label }) => `Performing extra action for ${label.toLowerCase()}, wait...`,
        PerformPurgeAction: ({ kind }) => `Waiting server response for ${kind.toLowerCase()}...`,
        Executing: 'Executing',
        Executed: 'Executed',
        'Awaiting execution': 'Awaiting execution'
    }
}
